module.exports = __webpack_public_path__ + "media/images/smart_phone/products/senbei2-c09634e94ce330a874cda3af7863548a.jpeg";